<template>
  <div>
    <el-tooltip placement="bottom-end" :key="index" :disabled="referer == 'report'">
      <div slot="content" style="font-size:10px">お気に入りに追加</div>
      <div class="data-table-th-favorite" @click="changeFavorite()" :class="[favorite == 1 ? 'favorite' : '', referer == 'list' || referer == 'report' ? 'list' : '']">
        <font-awesome-icon :icon="['fas', 'star']" style="font-size:12px" />
      </div>
    </el-tooltip>
    <el-tooltip placement="bottom-end" :disabled="referer == 'report'">
      <div slot="content" style="font-size:10px">お気に入りから削除</div>
      <div class="data-table-th-picture-favorite" :class="referer == 'list' || referer == 'report' ? 'list' : ''" @click="changeFavorite()" v-if="favorite == 1">
        <font-awesome-icon :icon="['fas', 'star']" style="font-size:12px" />
      </div>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: "favorite",
  props: ["favorite", "index", "referer"],
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {
    changeFavorite() {
      this.$emit("changeFavorite", this.index);
    },
  },
};
</script>

<style></style>
